import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Survey } from '../models/survey'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import type { SurveyState } from '../models/survey-state'

export const useSurveys = (query?: { states: SurveyState[] }) => {
  const { data, status, load, reload } = useGet<ReadonlyArray<Survey>>('survey')

  onMounted(() => load({ query: query }))

  const bus = useEventBus(EventKey.surveyUpdated)
  bus.on(() => reload({ query: query }))

  return { data, status, load }
}
